<template>
    <!-- Modal Detail User -->
    <CModal
    title="Modal title"
    :show.sync="modalDetailPembatalan"
    :no-close-on-backdrop="true"
    :centered="true"
    :closeOnBackdrop="false"
    @hide="closeModal"
    >
    <CRow ref="refmodal">
        <div class="modal-body row my-n3" >
            <div class="col-6" v-show="showButton">
                <div class="form-group">
                    <button 
                        class="btn btn-success" 
                        style="width:100%" 
                        @click="clickReschedule">
                        Reschedule
                    </button>
                </div>
            </div>
            <div class="col-6" v-show="showButton">
                <div class="form-group">
                    <button 
                        class="btn btn-info" 
                        style="width:100%"
                        @click="clickRefund">
                        Refund
                    </button>
                </div>
            </div>
           
            <div class="col-12" v-show="statusReschedule">
                <table style="width:100%" class="table">
                    <tr>
                        <td class="font-weight-bold">Tanggal </td>
                        <td>:</td>
                        <td style="text-align:center">
                            {{ formData.tanggal_ujian ? formData.tanggal_ujian : '-'  }}
                            <font-awesome-icon icon="arrow-right" class="text-success"  />
                            {{ detailData.tanggal_ujian ? detailData.tanggal_ujian : '-' }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <br>
                        </td>
                    </tr>
                    <tr >
                        <td rowspan="3" class="font-weight-bold">Test Center</td>
                        <td rowspan="3">:</td>
                        <td style="text-align:center">{{ detailData.nama_tc ? detailData.nama_tc : '-' }}</td>
                    </tr>
                    <tr>
                        <td>
                            <center>
                                <font-awesome-icon icon="arrow-down" class="text-success"  />
                            </center>
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align:center">{{ formData.nama_tc ? formData.nama_tc : '-' }}</td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <br>
                        </td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold">Sesi</td>
                        <td>:</td>
                        <td style="text-align:center">
                            {{ detailData.sesi ? detailData.sesi : '-' }}
                            <font-awesome-icon icon="arrow-right" class="text-success"  />
                            {{ formData.sesi ? formData.sesi : '-' }}
                        </td>
                    </tr>
                    <br>
                </table>
              
            </div>
            <div class="col-12" v-show="statusReschedule">
                <div class="form-group">
                    <label for="" class="font-weight-bold">Status Reschedule</label>
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="aktif"
                          value="1"
                          v-model="formPostPembatalan.status_pembatalan"
                        />
                        <label class="custom-control-label" for="aktif">Disetujui</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="tidak_aktif"
                          value="2"
                          v-model="formPostPembatalan.status_pembatalan"
                        />
                        <label class="custom-control-label" for="tidak_aktif">Ditolak</label>
                      </div>
                    </div>
                </div>
            </div>

        </div>
    </CRow>
    <template #header>
        <h6 class="modal-title h5 font-weight-bold">Detail Pembatalan</h6>
    </template>
    <template #footer>
        
        <CButton color="info" @click="postStatusPembatalan" v-show="showSimpan">Simpan</CButton>
        
        <CButton @click="tutupModal" color="danger">Tutup</CButton>
    </template>
    </CModal>
    <!-- End Modal -->
</template>
<script>
import DataPesertaService from "../../../services/sertifikasi/data-peserta.service"
export default {
    name: 'Modal',
    data() {
        return {
            detailData : {},
            formPostPembatalan : {
                id_mata_uji_peserta : '',
                status_pembatalan : '',
                insertMethod : ''
            },
            statusRefund : false,
            statusReschedule : false,
            showSimpan : false,
            showButton : true,
            insertMethod : "",
        }
    },
    components : {
    },
    props: [
        'modalDetailPembatalan',
        'title',
        'formData'
    ],
    mounted() {
    },
    methods : {
        getData() {
            let loader = this.$loading.show({
                container: false ? null : this.$refs.refmodal,
                canCancel: true,
                onCancel: this.onCancel
            });

            DataPesertaService.getDetailReschedule(this.formData.id_mata_uji_peserta)
            .then(res => {
                this.detailData = res.data.singleData
                loader.hide()
            }).catch(err => {
                // comment console console.log(err)
                loader.hide()
            })
        },
        closeModal() {
            this.statusRefund = false;
            this.statusReschedule = false;
            this.showButton = true;
            this.showSimpan = false;
        },
        tutupModal() {
            this.closeModal();
            this.$parent.tutupModal();
        },
        clickRefund() {
            this.showButton = false;
            this.statusRefund = true;
            this.showSimpan = true;
            this.formPostPembatalan.forminsertMethod = "refund";
        },
        clickReschedule(){
            this.getData()
            this.showButton = false;
            this.statusReschedule = true;
            this.showSimpan = true;
            this.formPostPembatalan.insertMethod = "reschedule";
            this.formPostPembatalan.id_mata_uji_peserta = this.formData.id_mata_uji_peserta
        },
        postStatusPembatalan() {
            this.$parent.postStatusPembatalan(this.formPostPembatalan);
        }
    },
    computed: {
      
    }
}
</script>